module.exports = __webpack_public_path__ + "static/Dashboard-38ea7938b3e5a859bf6fa42b60ac0e76.svg";